export function showApplyAccountPanel(panelName) {
    const container = document.querySelector('[data-apply-account]');
    if (!container) {
        return;
    }

    container.querySelectorAll('[data-apply-account-tab]').forEach((tab) => {
        tab.setAttribute('aria-selected', tab.dataset.applyAccountTab === panelName ? 'true' : 'false');
    });

    container.querySelectorAll('[data-apply-account-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.applyAccountPanel !== panelName;
    });
}

export default function() {
    const container = document.querySelector('[data-apply-account]');
    if (!container) {
        return;
    }

    container.querySelectorAll('[data-apply-account-tab]').forEach((tab) => {
        tab.addEventListener('click', () => showApplyAccountPanel(tab.dataset.applyAccountTab));
    });

    container.querySelectorAll('[data-password-toggle]').forEach((toggle) => {
        const input = document.getElementById(toggle.dataset.passwordToggle);
        const icon = toggle.querySelector('img');

        if (!input) {
            return;
        }

        toggle.addEventListener('click', () => {
            const isPassword = input.getAttribute('type') === 'password';

            input.setAttribute('type', isPassword ? 'text' : 'password');
            toggle.setAttribute('aria-label', isPassword ? 'Hide password' : 'Show password');

            if (icon) {
                icon.src = isPassword
                    ? '/images/my-account/eye-closed.svg'
                    : '/images/my-account/eye-open.svg';
            }
        });
    });
}
